import React from 'react'

// o children será o texto que é escrito no botão
// as colores recebe todas as cores do bulma sem o "IS-"
// o action recebe o função que ao apertar o botão ela será executada

export const ButtonContentDropDownButton = ({
  children,
  className = '',
  color = 'is-light',
  colorText = null,
  size = null,
  disabled = null,
  loading = null,
  titleBehind = '',
}) => {
  return (
    <div
      className="dropdown-trigger"
      style={{
        display: 'flex', // ativa flexbox
        flexDirection: 'column', // se quiser empilhar verticalmente
        justifyContent: 'center', // centraliza verticalmente
        alignItems: 'center', // centraliza horizontalmente
        marginTop: -30,
      }}
    >
      <button
        className={`button ${color} ${size} ${colorText} ${className} ${loading && 'is-loading'}`}
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        disabled={disabled}
      >
        {children}
      </button>
      {titleBehind !== '' ? (
        <p style={{ textAlign: 'center', fontSize: 10, maxWidth: '90%' }} className="has-text-grey mt-1">
          {titleBehind.split(' ').map((word, index) => (
            <span key={index} style={{ display: 'block' }}>
              {word}
            </span>
          ))}
        </p>
      ) : null}
    </div>
  )
}
